import { render, staticRenderFns } from "./EnrollmentResult.vue?vue&type=template&id=4bdd3aba&scoped=true&"
import script from "./EnrollmentResult.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentResult.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollmentResult.vue?vue&type=style&index=0&id=4bdd3aba&scoped=true&lang=scss&"
import style1 from "./EnrollmentResult.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdd3aba",
  null
  
)

export default component.exports